module.exports = __webpack_public_path__ + "img/BIAS.c38a96e8.gif";